import { Provider } from "@/types/supabase";

/**
 * Determines if a provider should be considered verified
 * Public verification is controlled by listing-level admin verification only.
 */
export const isProviderVerified = (
  provider: Provider, 
  _userProfileVerification?: boolean
): boolean => {
  return provider.is_verified;
};

/**
 * Helper to determine verification status for display purposes
 */
export const getVerificationStatus = (
  listingVerified: boolean,
  userProfileVerified: boolean
): {
  isVerified: boolean;
  source: 'listing' | 'profile' | 'both' | 'none';
} => {
  if (listingVerified) {
    return { isVerified: true, source: 'listing' };
  } else {
    return { isVerified: false, source: 'none' };
  }
};